//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class MailPlusClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getForm(formId: string): Promise<FormResponse> {
        let url_ = this.baseUrl + "/api/v1/mailplus/form/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForm(_response);
        });
    }

    protected processGetForm(response: Response): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse>(null as any);
    }
}

export class FilterClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getSearchFilters(language: string | null | undefined): Promise<{ [key: string]: ISearchFilter; }> {
        let url_ = this.baseUrl + "/api/filter/search?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchFilters(_response);
        });
    }

    protected processGetSearchFilters(response: Response): Promise<{ [key: string]: ISearchFilter; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: ISearchFilter; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: ISearchFilter; }>(null as any);
    }

    getCourseFilters(language: string | null | undefined): Promise<{ [key: string]: ISearchFilter; }> {
        let url_ = this.baseUrl + "/api/filter/courses?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCourseFilters(_response);
        });
    }

    protected processGetCourseFilters(response: Response): Promise<{ [key: string]: ISearchFilter; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: ISearchFilter; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: ISearchFilter; }>(null as any);
    }
}

export class CMSNodeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getSearch(searchRequest: SearchFilterRequest): Promise<PaginatedDTOOfOverviewItemDTO> {
        let url_ = this.baseUrl + "/api/overview/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch(_response);
        });
    }

    protected processGetSearch(response: Response): Promise<PaginatedDTOOfOverviewItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDTOOfOverviewItemDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDTOOfOverviewItemDTO>(null as any);
    }

    getCourses(searchRequest: SearchFilterRequest): Promise<PaginatedDTOOfOverviewCourseItemDTO> {
        let url_ = this.baseUrl + "/api/overview/courses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: Response): Promise<PaginatedDTOOfOverviewCourseItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDTOOfOverviewCourseItemDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDTOOfOverviewCourseItemDTO>(null as any);
    }
}

export class RedirectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllRedirects(page: number | undefined, pageSize: number | undefined): Promise<SearchResultOfRedirect> {
        let url_ = this.baseUrl + "/api/v1/redirects?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllRedirects(_response);
        });
    }

    protected processGetAllRedirects(response: Response): Promise<SearchResultOfRedirect> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchResultOfRedirect;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultOfRedirect>(null as any);
    }
}

export interface FormResponse {
    form: FormResponseDTO;
    formDetails: FormDTO | undefined;
}

export interface FormResponseDTO {
    html: string;
    script: string;
    isConfirmationPage: string;
    url: string | undefined;
}

export interface FormDTO {
    id: string;
    name: string;
    formSubType: string | undefined;
    formType: string;
}

export interface ISearchFilter {
    Kind: string | undefined;
}

export interface PaginatedDTOOfOverviewItemDTO {
    Rows: OverviewItemDTO[] | undefined;
    TotalItems: number;
    TotalPages: number;
}

export interface OverviewItemDTO {
    id: string | undefined;
    slug: string | undefined;
    absolutePath: string | undefined;
    pageTitle: string | undefined;
    kind: string | undefined;
    publicationDate: Date | undefined;
    categories: Category[] | undefined;
    headerInfo: HeaderInfo | undefined;
    teaserInfo: TeaserInfo | undefined;
}

export interface Category {
    Uuid: string;
    Id: number;
    Name: string | undefined;
    Group: string | undefined;
}

export interface HeaderInfo {
    label: string | undefined;
    title: string | undefined;
    introduction: string | undefined;
    image: File | undefined;
    actions: LinkContainer | undefined;
}

export interface FileBase {
    Height: number | undefined;
    Mime: string | undefined;
    Name: string | undefined;
    Size: number | undefined;
    Url: string | undefined;
    Width: number | undefined;
}

export interface File extends FileBase {
    AlternativeText: string | undefined;
    Caption: string | undefined;
    Formats: string | undefined;
}

export interface LinkContainer {
    ShowActionAsLink: boolean;
    PrimaryAction: Link | undefined;
    SecondaryAction: Link | undefined;
}

export interface Link {
    Kind: LinkDestination;
    Url: string | undefined;
    Label: string | undefined;
    IsPublished: boolean;
}

export type LinkDestination = "Internal" | "External";

export interface TeaserInfo {
    label: string | undefined;
    title: string | undefined;
    introduction: string | undefined;
    image: File | undefined;
}

export interface SearchFilterRequest {
    Slug: string | undefined;
    Locale: string | undefined;
    Page: number;
    PageSize: number;
    Kinds: string[] | undefined;
    Source: string | undefined;
    Filters: { [key: string]: ISearchFilter; } | undefined;
}

export interface PaginatedDTOOfOverviewCourseItemDTO {
    Rows: OverviewCourseItemDTO[] | undefined;
    TotalItems: number;
    TotalPages: number;
}

export interface OverviewCourseItemDTO extends OverviewItemDTO {
    duration: string | undefined;
    prices: SearchableEventTemplateProduct[] | undefined;
}

export interface EntityBase {
    Id: string;
    Title: string | undefined;
    Created: Date;
    Modified: Date;
}

export interface EventTemplateProduct extends EntityBase {
    EventTemplateId: string;
    Name: string | undefined;
    Amount: number | undefined;
    Quantity: number;
    AdditionalProduct: boolean;
    PriceType: number | undefined;
    State: number;
    Status: number;
}

export interface SearchableEventTemplateProduct extends EventTemplateProduct {
}

export interface SearchResultOfRedirect {
    Resources: Redirect[] | undefined;
    Count: number;
    PerPage: number;
    Total: number;
}

export interface Redirect {
    From: string | undefined;
    To: string | undefined;
    StatusCode: number | undefined;
    Source: string | undefined;
    Hits: number;
    Priority: number;
    LastHit: Date;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}